import {
	LayoutRoot,
	LayoutSideBar,
	LayoutSideBarFooter,
	LayoutSideBarHeader,
	LayoutTopBar,
	SidebarStatusActionTypes,
} from "@moznsystems/mozn-ui";
import {
	logoHorizontal,
	logoWordMark,
	useSidebarStatusContext,
} from "@rageeb/frontend-lib";
import { useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { AccountPreview } from "@/components/AccountPreview";
import { SideBar } from "./side-bar";
/**
 * Main application layout with header, navigation, and content area.
 * Used for authenticated pages.
 */
export const MainLayout = () => {
	const { sidebarStatus, handleSidebarStatus } = useSidebarStatusContext();
	const [isDrawerVisible, setDrawerVisible] = useState<boolean>(false);

	return (
		<LayoutRoot
			isSideBarClose={sidebarStatus === SidebarStatusActionTypes.CLOSE_SIDEBAR}
			contentWrapper={<div className="admin-layout-content" />}
		>
			<LayoutSideBar
				sidebarStatus={sidebarStatus}
				handleSidebarStatus={handleSidebarStatus}
				isDrawerVisible={isDrawerVisible}
				handleDrawerVisible={(value) => setDrawerVisible(value)}
			>
				<LayoutSideBarHeader>
					<NavLink to="/" className="logo" aria-label="Focal">
						<div className="logo__container logo__container--with-app-switcher">
							<img
								className="logo__container__horizontal"
								src={logoWordMark}
								alt="Focal's logo"
							/>
							<img
								className="logo__container__mini"
								src={logoWordMark}
								alt="Focal's logo"
							/>
							<p className="logo__container__text">
								<span>Fraud</span>
							</p>
						</div>
					</NavLink>
				</LayoutSideBarHeader>
				<SideBar setDrawerVisible={(value) => setDrawerVisible(value)} />
				<LayoutSideBarFooter>
					<div className="powered_by">
						<img src={logoHorizontal} alt="Mozn Logo" />
					</div>
				</LayoutSideBarFooter>
			</LayoutSideBar>
			<LayoutTopBar>
				<AccountPreview />
			</LayoutTopBar>
			<Outlet />
		</LayoutRoot>
	);
};
